<template>
  <div class="col-6 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">Crear un nuevo rol</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Rol </label>

                <el-input
                  v-model="formData.label"
                  v-validate="modelValidations.label"
                  name="label"
                  placeholder="Nombre del rol"
                >
                </el-input>

                <small v-show="label.invalid" class="text-danger">
                  {{ getError('label') }}
                </small>
              </div>
            </div>

            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';

export default {
  data() {
    return {
      validated: false,
      formName: 'formData',
      formData: {
        label: null,
      },

      modelValidations: {
        label: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['label']),
  },

  methods: {
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>
